//REGISTER
export const POST_REGISTER = "/users/register";
export const POST_REGISTER_TRIAL = "/users/registerTrial";

export const GET_API_KEY = "/users/login";
//LOGIN
export const POST_LOGIN = "/users/login";
export const POST_JWT_LOGIN = "/post-jwt-login";
export const POST_PASSWORD_FORGET = "/users/forgotPassword";
export const POST_PASSWORD_RESET = "/users/passwordReset";
export const POST_PASSWORD_SET = "/users/passwordSet";
export const POST_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/users";
export const EDIT_USER = "/users/settings";

// Product
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_BY_ID = "/products/ById";
export const GET_HOT_PRODUCTS = "/products/hot";
export const GET_MY_PRODUCTS = "/products/MyProducts";
export const DELETE_PRODUCT = "/products";
export const ADD_NEW_PRODUCT = "/products";
export const UPDATE_PRODUCT = "/products";
export const SET_PRODUCT_FLAG = "/products/setFlag";
export const DOWNLOAD_PRODUCTS = "/products/download";

// Orders
export const GET_ORDERS = "/order";
export const ADD_NEW_ORDER = "/order";
export const UPDATE_ORDER = "/order";
export const DELETE_ORDER = "/order";
export const CANCEL_ORDER = "/orders/cancel";
export const GET_INVOICE = "/orders/invoice";
// importFiles
export const GET_FILES = "/imports/admin/batches";
export const IMPORT_FILE = "/imports/admin/upload";
export const GET_IMPORTS = "/imports/admin";
export const UPDATE_ROW = "/imports/admin/updateRow";
export const UPDATE_STATUS = "/imports/admin/updatestatus";

export const GET_SUPPLIERS = "/suppliers";

export const GET_SETTINGS = "/adminSettings";
export const UPDATE_SETTINGS = "/adminSettings";
export const GET_GLOBAL_SETTINGS = "/settings/GlobalSettings";

export const ORDERS = "/orders";

export const GET_NOTIFICATIONS = "/notifications";
export const CHANGE_STATUS = "/notifications/changeStatus";

//PAYMENT
export const GET_DEFAULT_PAYMENT = "/users/defaultPM";
export const GET_PLAN_INFORMATION = "/users/planInformation";
export const UPDATE_PAYMENT = "/users/updatePaymentMethod";
export const SWITCH_PLAN = "/users/switchPlan";
export const CANCEL_PLAN = "/users/cancelSubscription";
export const UNCANCEL_PLAN = "/users/unCancelSubscription";
export const GET_SUBSCRIPTION_FREQUENCIES = "/users/SubscriptionFrequencies";
export const GET_STRIPE_SUBSCRIPTIONS = "/users/getStripeSubscriptions";
export const CREATE_SUBSCRIPTION = "/users/CreateSubscription";
export const CREATE_GHOST_SUBSCRIPTION = "/users/CreateGhostSubscription";
export const CREATE_GHOST_SUBSCRIPTION_CUSTOM = "/users/CreateGhostSubscriptionCustom";

// Quick Start
export const QUICK_START_STEP = "/users/QuickStartStep";
export const CHANNELS_ADDED = "/users/ChannelsAdded";
export const GET_TRIAL_DAYS = "/users/GetTrialDays";
